import {
  SIGN_OUT,
  GET_CREDITS,
  VOID_TOP_UP_TRANSACTION,
  SHOW_VOID_TOP_UP_TRANSACTION_DIALOG,
  HIDE_VOID_TOP_UP_TRANSACTION_DIALOG,
} from "../constants/ActionTypes";

const INIT_STATE = {
  credits: {
    data: [],
    count: 0
  },
  topUpTransactionVoiding: {
    isVoidingTransaction: false,
    currentVoidingTransaction: null
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case SIGN_OUT: {
      return INIT_STATE;
    }

    case GET_CREDITS: {
      return {
        ...state,
        credits: action.payload,
      };
    }

    case VOID_TOP_UP_TRANSACTION: {
      return state;
    }

    case SHOW_VOID_TOP_UP_TRANSACTION_DIALOG: {
      const payload = action.payload;

      const currentVoidingTransaction = typeof payload === 'string'
        ? state.credits.data.find(transaction =>
          transaction.walletTransactionUuid === payload || transaction.uuid === payload
        )
        : payload;

      return {
        ...state,
        topUpTransactionVoiding: {
          isVoidingTransaction: true,
          currentVoidingTransaction: currentVoidingTransaction
        }
      }
    }

    case HIDE_VOID_TOP_UP_TRANSACTION_DIALOG: {
      
      return {
        ...state,
        topUpTransactionVoiding: {
          isVoidingTransaction: false,
          currentVoidingTransaction: null
        }
      }
    }

    default:
      return state;
  }
}
